import React from 'react';
import {
  IconButton,
  Typography,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Box
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useSessao } from '../../redux/sessao/sessaoHooks';

type Props = {
  open: boolean;
};

const Logout: React.FC<Props> = ({ open }) => {
  const [sessao, , logout] = useSessao();

  const handleLogout = () => {
    logout();
  };

  return (
    <Box sx={{ px: 1.5 }}>
      {!open ? (
        <Tooltip title="Sair" placement="right" arrow>
          <IconButton
            onClick={handleLogout}
            sx={{
              width: '100%',
              py: 1.5,
              borderRadius: 2,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              color: 'error.main',
              '&:hover': {
                backgroundColor: 'error.light',
                color: 'error.contrastText',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)',
                '& .MuiSvgIcon-root': {
                  transform: 'scale(1.1)'
                }
              }
            }}
          >
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <ListItem disablePadding>
          <ListItemButton
            onClick={handleLogout}
            sx={{
              px: 2,
              py: 1.5,
              borderRadius: 2,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              color: 'error.main',
              border: '1px solid transparent',
              '&:hover': {
                backgroundColor: 'error.light',
                color: 'error.contrastText',
                border: '1px solid rgba(244, 67, 54, 0.3)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)',
                '& .MuiListItemIcon-root': {
                  transform: 'translateX(2px)'
                }
              },
              '&.Mui-focusVisible': {
                backgroundColor: 'error.light',
                color: 'error.contrastText'
              }
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 40,
                color: 'inherit',
                transition: 'all 0.3s ease',
                '& .MuiSvgIcon-root': {
                  transition: 'transform 0.3s ease'
                }
              }}
            >
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    color: 'inherit',
                    transition: 'color 0.3s ease'
                  }}
                >
                  Sair
                </Typography>
              }
              sx={{
                opacity: open ? 1 : 0,
                transition: 'opacity 0.2s ease 0.1s',
                ml: 1
              }}
            />
          </ListItemButton>
        </ListItem>
      )}
    </Box>
  );
};

export default Logout;
